"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function accountChanged(prevAccount, newAccount) {
  if (!prevAccount && !newAccount) return false;
  if (!prevAccount && newAccount) return true;
  if (prevAccount && !newAccount) return true;
  if (prevAccount && newAccount && prevAccount.id !== newAccount.id) return true;
  return false;
}

exports.accountChanged = accountChanged;

function newCurrentAccount(prevProps, newProps) {
  var prevAccount = prevProps && prevProps.currentAccount;
  var newAccount = newProps && newProps.currentAccount;
  return accountChanged(prevAccount, newAccount) && newAccount;
}

exports.newCurrentAccount = newCurrentAccount;
var ACCOUNT_UTILS = {
  accountChanged: accountChanged,
  newCurrentAccount: newCurrentAccount
};
exports.default = ACCOUNT_UTILS;